<template>
  <DeleteConfirm
      itemKey="TicketBonus"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import TicketBonuses from '@/services/ticket-bonuses'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return TicketBonuses
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť bonus z ' + this.$moment(Item.workedAt).format('DD.MM.YYYY') + ' od ' + Item.User.name
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť bonus z ' + this.$moment(Item.workedAt).format('DD.MM.YYYY') + ' od ' + Item.User.name + '?'
      },
      deleteData() {
        return TicketBonuses
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
